import { ReactNode } from 'react';
import { SelectProps as MuiSelectProps } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  MuiInputLabel,
  MuiFormControl,
  MuiFormHelperText,
} from '../../../../../modules/material';
import FieldStateAdornment from '../FieldStateAdornment';
import MenuItem from '../MenuItem';
import { StyledSelect } from './styles';

export type SelectOption = {
  value: string | number;
  label: string;
  subtitle?: string;
};

export interface SelectProps extends Omit<MuiSelectProps, 'variant'> {
  options: SelectOption[];
  completed?: boolean;
  blankOption?: SelectOption;
  helperText?: ReactNode;
}

export const renderSelectOptions = (options: SelectOption[]) =>
  options.map(({ value, label, subtitle }) => (
    <MenuItem key={value} value={value} subtitle={subtitle}>
      {label}
    </MenuItem>
  ));

export default function Select(props: SelectProps) {
  const {
    value = '',
    required,
    error,
    disabled,
    sx,
    fullWidth = true,
    color,
    label,
    size,
    helperText,
    completed,
    blankOption,
    options = [],
    children,
    ...selectProps
  } = props;

  return (
    <MuiFormControl
      variant="outlined"
      required={required}
      error={error}
      disabled={disabled}
      color={color}
      size={size}
      fullWidth={fullWidth}
      sx={sx}
    >
      {label && (
        <MuiInputLabel id={`label-id-${selectProps.name}`} variant="filled">
          {label}
        </MuiInputLabel>
      )}

      <StyledSelect
        value={value}
        IconComponent={ExpandMoreIcon}
        endAdornment={
          <FieldStateAdornment error={error} completed={completed} />
        }
        isLabel={!!label}
        isEndAdornment={error || completed}
        labelId={`label-id-${selectProps.name}`}
        {...selectProps}
      >
        {blankOption && (
          <MenuItem value={blankOption.value} subtitle={blankOption.subtitle}>
            {blankOption.label}
          </MenuItem>
        )}
        {options.length > 0 ? renderSelectOptions(options) : children}
      </StyledSelect>

      {helperText && <MuiFormHelperText>{helperText}</MuiFormHelperText>}
    </MuiFormControl>
  );
}
